// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j4c0","newExpiryDate":"styles_newExpiryDate__2S6Ys","footer":"styles_footer__5WU_J"};